import { crudSelectorsCustom } from 'redux/crudCreatorCustom/selector';
import { MODEL_NAME } from './actions';

export const centresOfMeBasicSelectors = crudSelectorsCustom(MODEL_NAME);
